export const ORDER_MADE = 'ORDER_MADE'
export const ERROR_ADDING_STORE =
  'An error occurred while adding to the store, please try again later.'
export const ERROR_FETCHING_STORE =
  'An error occurred while fetching the store, please try again later.'
export const ERROR_REJECTING_ORDER =
  'An error occurred while rejecting an order, please try again later.'
